import React, { Component } from "react";
import api from "../../api/promo-api";
import moment from "moment";

import Spinner from "react-bootstrap/Spinner";
import { Redirect } from "react-router-dom";

import Toast from "../../utils/toast";

export default class PromoAdd extends Component {
  constructor(props) {
    super(props);

    var code = props.match?.params?.code;

    if (code) {
      this._isUpdatingMode = true;
    } else {
      this._isUpdatingMode = false;
    }

    var today = moment().local().startOf("day");
    var expirationDate = today.add(14, "days");

    var expirationDateFormatted = expirationDate.format("DD.MM.YYYY HH:mm");
    var expirationDateUtc = expirationDate.utc().format();

    this.state = {
      isLoading: false,
      isFailed: false,
      toast: {
        isShow: false,
        alertType: null,
        message: null,
      },
      redirect: null,
      formattedDate: expirationDateFormatted,
      promo: {
        code: code,
        discount: "10%",
        expirationDate: expirationDateUtc,
        description: "",
      },
    };
  }

  componentDidMount = () => {
    if (this._isUpdatingMode) {
      this.setState({ isLoading: true });

      api
        .getPromoByCode(this.state.promo.code)
        .then((res) => {
          let formattedDate = null;
          if (res.data && res.data.expirationDate) {
            var m = moment.utc(res.data.expirationDate).local();
            formattedDate = m.format("DD.MM.YYYY HH:mm");
          }
          this.setState({
            formattedDate,
            promo: { ...res.data },
            isLoading: false,
            isFailed: false,
          });
        })
        .catch((error) => {
          this.setState({ isLoading: false, isFailed: true });
          let message = "";
          if (error.response) {
            message = `${error.response.status} ${error.response.statusText}:\n${error.response.data}`;
            // Request made and server responded
            console.log(error.response);
          } else if (error.request) {
            message = "no response";
            console.log(error.request);
          } else {
            message = "request failed";
            console.log("Error", error.message);
          }
          this.showMessage(message, "danger");
        });
    }
  };

  onInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const type = target.type;
    let value = null;

    if (type == "checkbox") {
      value = target.checked;
    } else {
      value = target.value;
    }

    var promo = { ...this.state.promo };
    this.setState({
      promo: {
        ...promo,
        [name]: value,
      },
    });
  };

  onDateChange = (event) => {
    var value = event.target.value;
    var parsedUtcDate = null;

    var parsedLocalDate = moment(value, "DD.MM.YYYY HH:mm");
    parsedUtcDate = parsedLocalDate.utc().format();

    var promo = { ...this.state.promo };
    this.setState({
      formattedDate: value,
      promo: {
        ...promo,
        expirationDate: parsedUtcDate,
      },
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    this.setState({
      isLoading: true,
    });

    if (this._isUpdatingMode) {
      api
        .updatePromo(this.state.promo)
        .then((res) => {
          this.setState({
            isLoading: false,
            redirect: "/promo",
          });
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          let message = "";
          if (error.response) {
            message = `${error.response.status} ${
              error.response.statusText
            }\n${JSON.stringify(error.response.data)}`;
            // Request made and server responded
            console.log(error.response);
          } else if (error.request) {
            message = "no response";
            console.log(error.request);
          } else {
            message = `request failed: ${error.message}`;
            console.log("Error", error.message);
            if (error.message === "Refresh token is outdated") {
              this.setState({
                redirect: "/login",
              });
            }
          }
          this.showMessage(message, "danger");
        });
    } else {
      api
        .insertPromo(this.state.promo)
        .then((res) => {
          this.setState({
            isLoading: false,
            redirect: "/promo",
          });
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          let message = "";
          if (error.response) {
            message = `${error.response.status} ${
              error.response.statusText
            }\n${JSON.stringify(error.response.data)}`;
            // Request made and server responded
            console.log(error.response);
          } else if (error.request) {
            message = "no response";
            console.log(error.request);
          } else {
            message = `request failed: ${error.message}`;
            console.log("Error", error.message);
            if (error.message === "Refresh token is outdated") {
              this.setState({
                redirect: "/login",
              });
            }
          }
          this.showMessage(message, "danger");
        });
    }
  };

  onCancelClick = (e) => {
    e.preventDefault();
    this.setState({
      redirect: "/promo",
    });
  };

  onCloseToast = () => {
    let toast = this.state.toast;
    this.setState({
      toast: {
        ...toast,
        isShow: false,
      },
    });
  };

  showMessage = (e, type = "success") => {
    let toast = this.state.toast;
    this.setState({
      toast: {
        ...toast,
        isShow: true,
        alertType: type,
        message: e.toString(),
      },
    });
  };

  render() {
    if (this.state.redirect) {
      return (
        <Redirect
          push
          to={{
            pathname: this.state.redirect,
            state: { from: "/promo" },
          }}
        />
      );
    }
    return (
      <div className="container">
        <Toast
          isShow={this.state.toast.isShow}
          onClose={this.onCloseToast}
          message={this.state.toast.message}
          alertType={this.state.toast.alertType}
        ></Toast>
        <div className="row justify-content-center">
          <div className="card mt-3" style={{ maxWidth: 700 }}>
            <div className="card-body">
              <h3>Редактирование промокода</h3>
              <div className={"d-none " + (this.state.isLoading ? "overlay" : "")}>
                <Spinner animation="border" />
              </div>
              <form onSubmit={this.handleSubmit}>
                <div className="form-group">
                  <label for="codeInput">Код</label>
                  <input
                    type="text"
                    className="form-control"
                    id="codeInput"
                    name="code"
                    value={this.state.promo.code}
                    onChange={(this, this.onInputChange)}
                    required
                    disabled={this._isUpdatingMode}
                  />
                </div>
                <div className="form-group">
                  <label for="discountInput">
                    Скидка (например, 200 или 10%)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="discountInput"
                    name="discount"
                    value={this.state.promo.discount}
                    onChange={(this, this.onInputChange)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label for="expirationDateInput">
                    Активный до (текущий часовой пояс)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="expirationDateInput"
                    value={this.state.formattedDate}
                    onChange={(this, this.onDateChange)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label for="descriptionInput">Описание</label>
                  <input
                    type="text"
                    className="form-control"
                    id="descriptionInput"
                    name="description"
                    value={this.state.promo.description}
                    onChange={(this, this.onInputChange)}
                  />
                </div>
                <button
                  onClick={this.onCancelClick}
                  className="mt-1 mr-2 btn btn-danger g-font-size-13 g-py-10"
                >
                  Отменить
                </button>
                <button
                  type="submit"
                  className="mt-1 btn u-btn-primary g-font-size-13 g-py-10"
                  disabled={this.state.isFailed}
                >
                  Сохранить
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
